var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpgradeBlock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.502,
    height: 27.5,
    viewBox: "0 0 27.502 27.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_927",
    "data-name": "Caminho 927",
    d: "M2.558,13.779,8.4,7.937a2.785,2.785,0,0,1,1.148-.7,2.681,2.681,0,0,1,1.356-.07l1.808.383a31.269,31.269,0,0,0-2.956,4.034A29.925,29.925,0,0,0,7.67,15.97Zm7.129,3.165a21.276,21.276,0,0,1,2.174-4.73,22.9,22.9,0,0,1,3.32-4.173,19.923,19.923,0,0,1,6.99-4.574,13.741,13.741,0,0,1,7.338-.921,13.832,13.832,0,0,1-.9,7.338,19.722,19.722,0,0,1-4.556,6.99,23.358,23.358,0,0,1-4.173,3.32A21.12,21.12,0,0,1,15.112,22.4Zm9.6-4.173a2.765,2.765,0,0,0,4.73-1.966,2.765,2.765,0,1,0-5.529,0A2.672,2.672,0,0,0,19.285,12.771ZM18.311,29.5l-2.226-5.112a30.776,30.776,0,0,0,4.4-2.087,30.57,30.57,0,0,0,4.051-2.956l.348,1.808a2.831,2.831,0,0,1-.765,2.539ZM4.783,21.4A4.092,4.092,0,0,1,7.739,20.16a3.969,3.969,0,0,1,2.956,1.2,4.2,4.2,0,0,1,0,5.912,7.063,7.063,0,0,1-2.9,1.5,36.852,36.852,0,0,1-5.617,1.113,36.262,36.262,0,0,1,1.113-5.6A7.054,7.054,0,0,1,4.783,21.4Z",
    transform: "translate(-2.175 -2.381)",
    fill: "#feac0e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpgradeBlock);
export default __webpack_public_path__ + "static/media/upgrade-block.1948f0aad3f745f545d38b6379269724.svg";
export { ForwardRef as ReactComponent };